// This custom cache doesn't support query params and only single pathname
"use client";

import { getPathnameWithoutLocale } from "@faire/web/ui/routing/util";
import { useCallback } from "react";

// This custom cache doesn't support query params and only single pathname

// This custom cache doesn't support query params and only single pathname

type CustomRouterCacheConfig = {
  staleTime?: number;
  lastUpdated?: number;
  lastRandomQueryParam?: string;
};

const getRandomString = () => {
  return Math.random().toString(36).substring(2, 6);
};

const CUSTOM_ROUTER_CACHE_QUERY_PARAM = "frc";

// This should in sync with the default stale time in NextJS config in seconds
export const DEFAULT_NEXTJS_STALE_TIME = 300;

const CustomRouterConfigMap = new Map<string, CustomRouterCacheConfig>([
  [
    "/",
    {
      staleTime: 1000 * 60, // 1 minute
      lastUpdated: 0,
      lastRandomQueryParam: "",
    },
  ],
]);

export const useCustomRouterCache = () => {
  const nextRouterStaleTime = DEFAULT_NEXTJS_STALE_TIME * 1000;
  const getModifiedUrl = useCallback(
    (url: string) => {
      const pathname = getPathnameWithoutLocale(url);
      const config = pathname ? CustomRouterConfigMap.get(pathname) : undefined;
      if (!config) {
        return url;
      }
      if (!config.lastUpdated) {
        config.lastUpdated = Date.now();
        return url;
      }
      if (config.lastUpdated && config.staleTime) {
        const timeSinceLastUpdate = Date.now() - config.lastUpdated;
        const isStale =
          timeSinceLastUpdate < nextRouterStaleTime &&
          timeSinceLastUpdate > config.staleTime;
        if (isStale) {
          config.lastRandomQueryParam = getRandomString();
          config.lastUpdated = Date.now();
        }
      }
      if (config.lastRandomQueryParam) {
        const [base, existingQuery] = url.split("?");
        const searchParams = new URLSearchParams(existingQuery);
        searchParams.set(
          CUSTOM_ROUTER_CACHE_QUERY_PARAM,
          config.lastRandomQueryParam
        );
        return base + "?" + searchParams.toString();
      }
      return url;
    },
    [nextRouterStaleTime]
  );
  const getCacheTTL = useCallback(
    (url: string) => {
      const pathname = getPathnameWithoutLocale(url);
      const config = pathname ? CustomRouterConfigMap.get(pathname) : undefined;
      if (!config) {
        return nextRouterStaleTime;
      }
      return config.staleTime ?? nextRouterStaleTime;
    },
    [nextRouterStaleTime]
  );
  return {
    getModifiedUrl,
    getCacheTTL,
  };
};
